import React, { useEffect, useState } from 'react';
import { Badge, Button, Form, Image, Modal } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import InfoComplete from './InfoComplete';
import GenereCsv from './GenereCsv';
import { cleanJson } from './utils/Columns';
import { FaBan, FaCheck, FaCity, FaPhone, FaRegEnvelope, FaTimes, FaUser } from 'react-icons/fa';
import tribu from './assets/images/logo_tribu.png'; // Importez le chemin de votre image
import moment from 'moment';
import TribuAction from './TribuAction';

const Tribu = ({ gotoAuth, annee, tribus, reloadTribus }) => {

    const url = localStorage.getItem('url');
    const code = localStorage.getItem('code');
    const [show, setShow] = useState(false);
    const [showTribu, setShowTribu] = useState(false);
    const [adherentSel, setAdherentSel] = useState({});
    // Filtrer les articles initialisés et non initialisés

    const [searchText, setSearchText] = useState('');
    const [adherents, setAdherents] = useState([]);
    const [dataFiltered, setDataFiltered] = useState([]);

    const getAdherent = () => {
        if (code && code !== '')
            return fetch(`${url}getTribu/${code}`)
                .then(response => response.json())
                .then(data => {
                    console.log('Réponse du serveur:', data);
                    let adh = cleanJson(data.crm);
                    setAdherents(adh);
                    setDataFiltered([...adh]);
                    compteFiltreParBouton(adh);
                })
                .catch(error => console.error('Erreur:', error));
    };

    useEffect(() => {
        getAdherent();
    }, [annee]);

    const [boutonSel, setBoutonSel] = useState({ label: 'ok actif', has_tribu: 1, has_tribu_actif: 1, mail_correct: 1, acces_interdit: 0 });

    const [lesBoutons, setLesBoutons] = useState([
        { label: 'ok actif', has_tribu: 1, has_tribu_actif: 1, mail_correct: 1, acces_interdit: 0, compte: null, quantite: -1, has_region: null },
        { label: 'ok région', has_tribu: 1, has_tribu_actif: null, mail_correct: null, acces_interdit: 0, compte: null, quantite: -1, has_region: 1 },
        // { label: 'ok inactif', has_tribu: 0, has_tribu_actif: 0, mail_correct: null, acces_interdit: 1, compte: null, quantite: -1, has_region: null },
        { label: 'ko has_tribu', has_tribu: 0, has_tribu_actif: null, mail_correct: null, acces_interdit: null, compte: null, quantite: -1, has_region: null },
        { label: 'ko has_tribu_actif', has_tribu: null, has_tribu_actif: 0, mail_correct: null, acces_interdit: null, compte: null, quantite: -1, has_region: 0 },
        { label: 'ko mail_correct', has_tribu: null, has_tribu_actif: null, mail_correct: 0, acces_interdit: null, compte: null, quantite: -1, has_region: null },
        { label: 'ko que mail_correct=0', has_tribu: 1, has_tribu_actif: 1, mail_correct: 0, acces_interdit: 0, compte: null, quantite: -1, has_region: null },
        { label: 'ko acces_interdit', has_tribu: null, has_tribu_actif: null, mail_correct: null, acces_interdit: 1, compte: null, quantite: -1, has_region: null },
        { label: 'compte bloqué dans tribu mais qui ne devraient pas', has_tribu: 1, has_tribu_actif: 1, mail_correct: 1, acces_interdit: 1, compte: null, quantite: -1, has_region: null },
        { label: 'compte absent', has_tribu: null, has_tribu_actif: 1, mail_correct: null, acces_interdit: null, compte: 1, quantite: -1, has_region: null },
    ]);

    const getFiltres = (b, data) => {
        return data.filter(item => {
            let res = true;
            if (b.has_tribu !== null) res = item.has_tribu === b.has_tribu ? res && true : res && false;
            if (b.mail_correct !== null) res = item.mail_correct === b.mail_correct ? res && true : res && false;
            if (b.acces_interdit !== null) res = item.acces_interdit === b.acces_interdit ? res && true : res && false;
            if (b.has_region !== null) res = item.has_region === b.has_region ? res && true : res && false;
            if (b.has_tribu_actif !== null && b.compte !== null) res = item.login === null ? res && true : res && false;
            if (b.has_tribu_actif !== null) res = item.has_tribu_actif === b.has_tribu_actif ? res && true : res && false;
            return res;
        });
    }

    const compteFiltreParBouton = (data) => {
        let newBoutons = [...lesBoutons];
        for (let b of newBoutons) {
            // if (b.quantite === -1)
            b.quantite = getFiltres(b, data).length;
        }
        console.log('Compte :', newBoutons);
        setLesBoutons([...newBoutons]);
    }

    // const filtreV1 = (data) => {
    //     const filtered = data.filter(item => {
    //         return item.has_tribu === 1 && item.has_tribu_actif === 0 && item.acces_interdit === null;
    //     });
    //     setDataFiltered([...filtered]);
    // }

    const filtreAll = (b, data) => {
        console.log('Filtre :', b);
        setBoutonSel(b);
        const filtered = getFiltres(b, data);
        setDataFiltered([...filtered]);
        console.log(filtered);

        //filtre(searchText, filtered);
    }


    const filtre = (value, data) => {
        setSearchText(value);
        if (value.length < 1) {
            setDataFiltered(data);
        } else {
            const filtered = data.filter(item => {
                // must contains all word of value

                return value.split(' ').every(word => {
                    return JSON.stringify(item).toLowerCase().includes(word.toLowerCase());
                });
            });
            setDataFiltered(filtered);
            // console.log(filtered);
        }
    }

    const handleChangesearchText = (e) => {
        filtre(e.target.value, adherents);
    };

    const handleClose = () => setShow(false);

    const handleShow = (row) => {
        setAdherentSel(row);
        setShowTribu(true);
    }

    const handleModifCrmSansReload = (table, id, champ, valeur) => {
        console.log('Modif :', table, id, champ, valeur);
        // return;
        fetch(`${url}modifCrm/${table}/${id}/${champ}/${valeur}/${code}`)
            .then(response => response.json())
            .then(data => {
                console.log('ok');
            })
            .catch(error => console.error('Erreur:', error));
    }


    const handleAfterModifTribu = () => {
        reloadTribus();
        getAdherent().then(() => filtreAll(boutonSel, adherents));
        setShowTribu(false);
    }

    const handleModifCrm = (table, id, champ, valeur) => {
        console.log('Modif :', table, id, champ, valeur);
        // return;
        fetch(`${url}modifCrm/${table}/${id}/${champ}/${valeur}/${code}`)
            .then(response => response.json())
            .then(data => {
                console.log('Réponse du serveur:', data);
                getAdherent().then(() => filtreAll(boutonSel, adherents));
            })
            .catch(error => console.error('Erreur:', error));
    }

    const columns = [
        {
            name: 'Adhérent CRM', selector: row => row.nom_adherent, cell: row => (<table>
                <tbody>
                    <tr><td><b>{row.nom_de_l_entreprise}</b></td></tr>
                    <tr><td><FaUser />&nbsp;{row.nom_adherent} {row.prenom_adherent}</td></tr>
                    {row.e_mail_1 && <tr><td><FaRegEnvelope />&nbsp;{row.e_mail_1}</td></tr>}
                    {row.e_mail_2 && <tr><td><FaRegEnvelope />&nbsp;{row.e_mail_2}</td></tr>}
                    {row.e_mail_3 && <tr><td><FaRegEnvelope />&nbsp;{row.e_mail_3}</td></tr>}
                    <tr><td><FaCity />&nbsp;{row.adresse1}</td></tr>
                    <tr><td><FaCity />&nbsp;{row.code_postal} {row.ville}</td></tr>
                </tbody>
            </table>), sortable: true, wrap: true
        },
        {
            name: 'Adhérent TRIBU', selector: row => row.nom, cell: row => (<table>
                <tbody>
                    <tr><td><b>{row.nom}</b></td></tr>
                    {row.mail && <tr><td><FaRegEnvelope />&nbsp;{row.mail}</td></tr>}
                    <tr><td><FaCity />&nbsp;{row.adresse}</td></tr>
                    <tr><td><FaCity />&nbsp;{row.cp} {row.ville1}</td></tr>
                </tbody>
            </table>), sortable: true, wrap: true
        },
        {
            name: 'identifiant_tribu', selector: row => row.identifiant_tribu, cell: row => (<div>
                {row.identifiant_tribu}<br />
                {row.login}
            </div>
            ), sortable: true, wrap: true
        },
        {
            name: 'infos', selector: row => row.has_tribu, cell: row => (
                <div>
                    {row.fin_periode && <p>Fin de période : {moment(row.fin_periode).format('DD/MM/YYYY')}</p>}
                    <FaCheck style={{ color: row.has_tribu === 1 ? 'green' : 'red' }} /> has_tribu : {row.has_tribu === 1 ? 'OK' : 'KO'}<br />
                    <FaCheck style={{ color: row.has_tribu_actif === 1 ? 'green' : 'red' }} /> has_tribu_actif : {row.has_tribu_actif === 1 ? 'OK' : 'KO'} Est abonné tribu pour cette année<br />
                    <FaCheck style={{ color: row.mail_correct === 1 ? 'green' : 'red' }} /> mail_correct : {row.mail_correct === 1 ? 'OK' : 'KO'}<br />
                    {/* acces_interdit */}
                    <FaCheck style={{ color: row.acces_interdit === 0 ? 'green' : 'red' }} /> acces_interdit : {row.acces_interdit === 0 ? 'NON' : 'OUI'}<br />
                    {row.has_region === 1 && (<><FaCheck style={{ color: row.has_region === 1 ? 'green' : 'red' }} /> has_region : {row.has_region === 1 ? 'OUI' : 'NON'}<br /></>)}
                </div>
            ), sortable: true, wrap: true
        },
        {
            name: 'action', selector: row => row.has_tribu, cell: row => (
                <div>
                    {row.has_region === 1 && <>
                        REGION
                        {row.has_tribu_actif === 0 && row.has_tribu === 1 && row.acces_interdit === 0 && row.mail_correct === 1 && <FaCheck style={{ color: 'green' }} />}
                        {!(row.has_tribu_actif === 0 && row.has_tribu === 1 && row.acces_interdit === 0 && row.mail_correct === 1) && <p> PROBLEME </p>}
                        {/* {row.has_tribu_actif === 1 && (row.has_tribu === 0 || row.acces_interdit === 1 || row.mail_correct === 0) && <p> PROBLEME </p>}
                        {row.has_tribu_actif === 1 && row.has_tribu === 0 && <p> passer has_tribu à 1 </p>}
                        {row.has_tribu_actif === 1 && row.acces_interdit === 1 && <p> passer acces_interdit à 0 </p>}
                        {row.has_tribu_actif === 1 && row.mail_correct === 0 && <p> ajouter le mail de tribu au crm </p>}
                        {row.has_tribu_actif === 0 && row.has_tribu === 1 && <p> passer has_tribu à 0 </p>}
                        {row.has_tribu_actif === 0 && row.acces_interdit === 0 && <p> passer acces_interdit à 1 </p>}
                        {row.has_tribu_actif === 1 && row.login === null && <p> créer un compte dans tribu </p>}
                        {row.has_tribu_actif === 1 && row.login !== row.identifiant_tribu && <p> le compte tribu est incohérent avec le CRM </p>}
                        <p>Action CRM</p>
                        {row.has_tribu_actif === 1 && row.has_tribu === 0 && <Button variant='outline-primary' onClick={() => handleModifCrm('tribu', row.t_id, 'has_tribu', 1)}>Passer has_tribu à 1</Button>}
                        {row.has_tribu_actif === 1 && row.mail_correct === 0 && row.mail && <Button variant='outline-primary' onClick={() => handleModifCrm('adherent', row.a_id, row.e_mail_1 === '' ? 'e_mail_1' : (row.a_id, row.e_mail_2 === '' ? 'e_mail_2' : (row.a_id, row.e_mail_3 === '' ? 'e_mail_3' : 'aucun')), row.mail)}>Ajouter le mail de tribu</Button>}
                        {row.has_tribu_actif === 1 && row.mail_correct === 0 && row.mail?.trim() === '' && <Button variant='outline-danger ' onClick={() => handleModifCrm('adherent', row.a_id, row.e_mail_1 === '' ? 'e_mail_1' : (row.a_id, row.e_mail_2 === '' ? 'e_mail_2' : (row.a_id, row.e_mail_3 === '' ? 'e_mail_3' : 'aucun')), row.mail)}>Le mail de tribu est vide le compte est mal créé</Button>}
                        <p>Action TRIBU</p> */}
                    </>}
                    {row.has_region !== 1 && <>
                        {row.has_tribu_actif === 1 && (row.has_tribu === 0 || row.acces_interdit === 1 || row.mail_correct === 0) && <p> PROBLEME </p>}
                        {row.has_tribu_actif === 1 && row.has_tribu === 0 && <p> passer has_tribu à 1 </p>}
                        {row.has_tribu_actif === 1 && row.acces_interdit === 1 && <p> passer acces_interdit à 0 </p>}
                        {row.has_tribu_actif === 1 && row.mail_correct === 0 && <p> ajouter le mail de tribu au crm </p>}
                        {row.has_tribu_actif === 0 && row.has_tribu === 1 && <p> passer has_tribu à 0 </p>}
                        {row.has_tribu_actif === 0 && row.acces_interdit === 0 && <p> passer acces_interdit à 1 </p>}
                        {row.has_tribu_actif === 1 && row.login === null && <p> créer un compte dans tribu </p>}
                        {row.has_tribu_actif === 1 && row.login !== row.identifiant_tribu && <p> le compte tribu est incohérent avec le CRM </p>}
                        <p>Action CRM</p>
                        {row.has_tribu_actif === 1 && row.has_tribu === 0 && <Button variant='outline-primary' onClick={() => handleModifCrm('tribu', row.t_id, 'has_tribu', 1)}>Passer has_tribu à 1</Button>}
                        {row.has_tribu_actif === 1 && row.mail_correct === 0 && row.mail && <Button variant='outline-primary' onClick={() => handleModifCrm('adherent', row.a_id, row.e_mail_1 === '' ? 'e_mail_1' : (row.a_id, row.e_mail_2 === '' ? 'e_mail_2' : (row.a_id, row.e_mail_3 === '' ? 'e_mail_3' : 'aucun')), row.mail)}>Ajouter le mail de tribu</Button>}
                        {row.has_tribu_actif === 1 && row.mail_correct === 0 && row.mail?.trim() === '' && <Button variant='outline-danger ' onClick={() => handleModifCrm('adherent', row.a_id, row.e_mail_1 === '' ? 'e_mail_1' : (row.a_id, row.e_mail_2 === '' ? 'e_mail_2' : (row.a_id, row.e_mail_3 === '' ? 'e_mail_3' : 'aucun')), row.mail)}>Le mail de tribu est vide le compte est mal créé</Button>}
                        <p>Action TRIBU</p>
                    </>}
                </div>
            ), sortable: true, wrap: true
        },
        // {
        //     name: '', width: '70px', selector: row => row.nom_de_l_entreprise, cell: row => (
        //         <Button variant='outline-primary' onClick={() => handleShow(row)}><FaTimes /></Button>
        //     ), sortable: true, wrap: true
        // }

    ];

    const handleRowClick = (row) => {
        console.log('Ligne cliquée :', row);
        // Faites ce que vous voulez avec la ligne cliquée ici
        handleShow(row);
    };

    const [wait, setWait] = useState(false);
    const getTribus = () => {
        setWait(true);
        fetch(`${url}gettribufromtribu`)
            .then(response => response.json())
            .then(data => {
                setTimeout(() => {
                    setWait(false);
                    reloadTribus();
                    getAdherent();
                }, 8000);

            })
            .catch(error => {
                console.error('Erreur:', error)
                alert('Erreur lors de la récupération des données de tribu');
                setWait(false);
            });
    }

    const cleanCrmV1 = () => {
        let adhs = adherents.filter(item => item.has_tribu === 1 && item.has_tribu_actif === 0 && (item.acces_interdit === 1 || item.acces_interdit === null))
        console.log(adhs);
        adhs.forEach(e => {
            handleModifCrmSansReload('tribu', e.t_id, 'has_tribu', 0);
        });
    }

    const cleanCrmV2 = () => {
        let adhs = adherents.filter(item => item.has_tribu === 0 && item.has_tribu_actif === 1 && item.acces_interdit === 0 && item.mail_correct === 1 && item.login === item.identifiant_tribu)
        console.log(adhs);
        adhs.forEach(e => {
            handleModifCrmSansReload('tribu', e.t_id, 'has_tribu', 1);
            handleModifCrmSansReload('tribu', e.t_id, 'fin_periode', `${annee}-12-31`);
        });
    }

    // //Nettoyer le crm quand le mail tribu n'est pas dans le crm
    // const cleanCrmV3 = () => {
    //     let adhs = adherents.filter(item => item.has_tribu === 1 && item.has_tribu_actif === 1 && item.mail_correct === 0 && item.login === item.identifiant_tribu && item.acces_interdit === 0 && (item.e_mail_1 === '' || item.e_mail_2 === '' || item.e_mail_3 === '') && item.mail !== '' && item.mail != null)
    //     console.log(adhs);
    //     adhs.forEach(e => {
    //         handleModifCrmSansReload('adherent', e.a_id, e.e_mail_2 === '' || e.e_mail_2 === 'null' ? 'e_mail_2' : (e.e_mail_1 === '' || e.e_mail_1 === 'null' ? 'e_mail_1' : (e.e_mail_3 === '' || e.e_mail_3 === 'null' ? 'e_mail_3' : 'aucun')), e.mail);
    //     });
    // }

    //Nettoyer le crm quand l'adherent n'est pas abonné et compte tribu bloqué
    const cleanCrmV4 = () => {
        let adhs = adherents.filter(item => item.has_tribu === 1 && item.has_tribu_actif === 0 && item.acces_interdit === 1)
        console.log(adhs);
        adhs.forEach(e => {
            handleModifCrmSansReload('tribu', e.t_id, 'has_tribu', 0);
            handleModifCrmSansReload('tribu', e.t_id, 'fin_periode', moment().format('YYYY-MM-DD'));
        });
    }

    const cleanCrmV5 = () => {
        let adhs = adherents.filter(item => item.mail_correct === 0 && item.mail !== '' && item.mail != null && (item.e_mail_1 === '' || item.e_mail_2 === '' || item.e_mail_3 === ''))
        console.log(adhs);
        adhs.forEach(e => {
            if (e.e_mail_1 === '' || e.e_mail_2 === '' || e.e_mail_3 === '')
                handleModifCrmSansReload('adherent', e.a_id, e.e_mail_2 === '' ? 'e_mail_2' : (e.e_mail_1 === '' ? 'e_mail_1' : 'e_mail_3'), e.mail);
        });
    }

    const cleanCrmV6 = () => {
        let adhs = adherents.filter(item => item.has_tribu === 1 && item.has_tribu_actif === 0 && item.acces_interdit === null)
        console.log(adhs);
        adhs.forEach(e => {
            handleModifCrmSansReload('tribu', e.t_id, 'has_tribu', 0);
            handleModifCrmSansReload('tribu', e.t_id, 'fin_periode', moment().format('YYYY-MM-DD'));
        });
    }

    const urltribu = `https://webservices.k-lix.com/TribuPrd.aspx`;

    const ModifTribu = (table, id, champ, valeur) => {
        console.log('Modif :', table, id, champ, valeur);
        // return;
        let obj = { action: 'updateobj', table, ID: id, [champ]: valeur };

        //Post
        fetch(urltribu, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: JSON.stringify(obj)
        })
            .then(response => response.json())
            .then(data => {
                console.log('Réponse du serveur:', data);
            })
            .catch(error => console.error('Erreur:', error));
    }

    // cleanCrmV7()}>Bloque les tiers qui n'ont pas souscrit
    const cleanCrmV7 = () => {
        let adhs = adherents.filter(item => item.has_tribu === 1 && item.has_tribu_actif === 0 && item.acces_interdit === 0 && item.has_region === 0)
        console.log(adhs);
        // adhs.forEach(e => {
        //     handleModifCrmSansReload('tribu', e.t_id, 'has_tribu', 0);
        //     handleModifCrmSansReload('tribu', e.t_id, 'fin_periode', moment().format('YYYY-MM-DD'));
        //     ModifTribu('T_GARAGE', e.tft_id, 'acces_interdit', 1);
        // });
        // setTimeout(() => {
        //     handleAfterModifTribu();
        // }, 20000);


        // let ids = [3351, 10051, 5563, 236, 7803, 3325, 5530, 3410, 9637, 7631, 7679, 9387, 3342, 6594, 10277, 3297, 3292, 7646, 9981, 3371, 6616];
        // // handleModifCrmSansReload('tribu', 3351, 'has_tribu', 1);
        // // handleModifCrmSansReload('tribu', 3351, 'fin_periode', '2026-12-31');
        // // ModifTribu('T_GARAGE', 3351, 'acces_interdit', 0);
        // ids.forEach(e => {
        //     handleModifCrmSansReload('tribu', e, 'has_tribu', 1);
        //     handleModifCrmSansReload('tribu', e, 'fin_periode', '2027-12-31');
        //     ModifTribu('T_GARAGE', e, 'acces_interdit', 0);
        // });

    }

    return (<>
        {wait && <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>

            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>}

        {!wait &&
            <div>
                <div className="row">
                    <div className='col-12'>
                        <div className="d-grid gap-2">
                            <Button variant='warning' onClick={() => getTribus()}>Récupère les données de tribu</Button>
                        </div>
                    </div>
                    <div className='col-12'>
                        <div className="d-grid gap-2">
                            <Button variant='success' onClick={() => {
                                setWait(true);
                                fetch(`${url}majsirettribu`)
                                    .then(response => response.json())
                                    .then(data => {
                                        })
                                    .catch(error => {
                                        console.error('Erreur:', error);
                                        alert('Erreur lors de la mise à jour des SIRET depuis tribu');
                                        setWait(false);
                                    });
                            }}>
                                Met à jour les SIRET depuis tribu
                            </Button>
                        </div>
                    </div>
                    <br />
                    <br />
                    <hr />
                    <div className='col-3'>
                        <div className="d-grid gap-2">
                            <Button variant='outline-success' onClick={() => cleanCrmV1()}>Nettoyer le crm retirant de l'onglet tribu ceux qui ne devrait pas y etre</Button>
                        </div></div>
                    <div className='col-3'>
                        <div className="d-grid gap-2">
                            <Button variant='outline-success' onClick={() => cleanCrmV2()}>Nettoyer le crm rajoutant de l'onglet tribu ceux qui devrait y etre</Button>
                        </div></div>
                    {/* <div className='col-3'><div className="d-grid gap-2">
                        <Button variant='outline-success' onClick={() => cleanCrmV3()}>Nettoyer le crm quand le mail tribu n'est pas dans le crm</Button>
                    </div></div> */}
                    <div className='col-3'><div className="d-grid gap-2">
                        <Button variant='outline-success' onClick={() => cleanCrmV4()}>Nettoyer le crm quand l'adherent n'est pas abonné et compte tribu bloqué</Button>
                    </div></div>
                    <div className='col-3'><div className="d-grid gap-2">
                        <Button variant='outline-success' onClick={() => cleanCrmV5()}>Nettoyer le crm quand le mail tribu n'est pas dans le crm</Button>
                    </div></div>
                    <div className='col-3'><div className="d-grid gap-2">
                        <Button variant='outline-success' onClick={() => cleanCrmV6()}>Nettoyer le crm quand l'adherent n'est pas abonné et n'a pas tribu et has_tribu est validé</Button>
                    </div></div>
                    <div className='col-3'><div className="d-grid gap-2">
                        <Button variant='outline-info' onClick={() => cleanCrmV7()}>Bloque les tiers qui n'ont pas souscrit</Button>
                    </div></div>
                </div>
                <div className="row">
                    {lesBoutons.map((item, index) => (
                        <div className='col-2' key={'btn-' + index}>
                            <div className="d-grid gap-2">
                                <Button variant={JSON.stringify(boutonSel) === JSON.stringify(item) ? 'primary' : 'outline-primary'} onClick={() => filtreAll(item, adherents)}>
                                    {item.label}&nbsp;
                                    <Badge bg="secondary">{item.quantite}</Badge>
                                </Button>
                            </div>
                        </div>
                    ))}
                    {/* <div className="d-grid gap-2">
                        <Button variant='outline-primary' onClick={() => filtreV1(adherents)}>
                            Sans tribu mais marqué comme s'il l'avaient&nbsp;
                        </Button>
                    </div> */}
                </div>
                <DataTable
                    columns={columns}
                    data={dataFiltered}
                    pagination={true}
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                    highlightOnHover
                    subHeader
                    subHeaderComponent={(
                        // <div style={{ display: 'flex', alignItems: 'center' }}>

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>

                            <input
                                type="text"
                                value={searchText}
                                onChange={handleChangesearchText}
                                // onChange={(e) => setSearchText(e.target.value)}
                                placeholder="Rechercher..."
                            />
                            {searchText && <FaTimes className='h-5' onClick={() => filtre('', adherents)} />}
                            <div style={{ flexGrow: 1 }} />
                            <GenereCsv data={dataFiltered} fichier="Adherent" visible={true} />
                        </div>
                    )}
                    defaultSortField="id"
                    defaultSortAsc={false}
                    subHeaderAlign="left"
                    noHeader={true}
                    paginationComponentOptions={{
                        rowsPerPageText: 'Lignes par page:',
                    }}
                    onRowClicked={handleRowClick}
                />
                <hr />

                <Modal size="xl" show={show} onHide={handleClose}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton />
                    <Modal.Body>
                        <InfoComplete adherentLight={adherentSel} />
                    </Modal.Body>
                </Modal>
                <Modal size="xl" show={showTribu} onHide={() => setShowTribu(false)}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton />
                    <Modal.Body>
                        {/* // annee, adherentSel, handleModifTribu, handleModifCrm */}
                        <TribuAction annee={annee} adherentSel={adherentSel} tribus={tribus} handleAfterModif={handleAfterModifTribu} />
                    </Modal.Body>
                </Modal>
            </div>
        }</>
    );
}

export default Tribu;
